
import { Component, Vue, Watch } from 'vue-property-decorator'
import { Route } from 'vue-router'
import { Dictionary } from 'vue-router/types/router'
import { Form as ElForm, Input } from 'element-ui'
import { UserModule } from '@/store/modules/user'
import { getRememberMe, setRememberMe, getRememberedUsername, setRememberedUsername, getRememberedPassword, setRememberedPassword, removeRememberedUsername, removeRememberedPassword } from '@/utils/storage'

@Component({
  name: 'Login'
})
export default class extends Vue {
  public validateUsername = (rule: any, value: string, callback: Function) => {
    // if (!isValidUsername(value)) {
    //   callback(new Error('Please enter the correct user name'))
    // } else {
    //   callback()
    // }
    callback()
  }

  public validatePassword = (rule: any, value: string, callback: Function) => {
    if (value.length < 6) {
      callback(new Error('The password can not be less than 6 digits'))
    } else {
      callback()
    }
  }

  public loginForm = {
    username: '',
    password: ''
  }

  public loginRules = {
    username: [{ validator: this.validateUsername, trigger: 'blur' }],
    password: [{ validator: this.validatePassword, trigger: 'blur' }]
  }

  public passwordType = 'password'
  public loading = false
  public showDialog = false
  public redirect?: string
  public otherQuery: Dictionary<string> = {}
  public rememberMe = false

  @Watch('$route', { immediate: true })
  public onRouteChange(route: Route) {
    // TODO: remove the "as Dictionary<string>" hack after v4 release for vue-router
    // See https://github.com/vuejs/vue-router/pull/2050 for details
    const query = route.query as Dictionary<string>
    if (query) {
      this.redirect = query.redirect
      this.otherQuery = this.getOtherQuery(query)
    }
  }

  mounted() {
    // 加载记住的账号密码
    this.rememberMe = getRememberMe()
    if (this.rememberMe) {
      this.loginForm.username = getRememberedUsername()
      this.loginForm.password = getRememberedPassword()
    }

    if (this.loginForm.username === '') {
      (this.$refs.username as Input).focus()
    } else if (this.loginForm.password === '') {
      (this.$refs.password as Input).focus()
    }

  }

  public showPwd() {
    if (this.passwordType === 'password') {
      this.passwordType = ''
    } else {
      this.passwordType = 'password'
    }
    this.$nextTick(() => {
      (this.$refs.password as Input).focus()
    })
  }

  public handleLogin() {
    (this.$refs.loginForm as ElForm).validate(async(valid: boolean) => {
      if (valid) {
        this.loading = true
        try {
          // 保存或清除记住的账号密码
          if (this.rememberMe) {
            setRememberMe(true)
            setRememberedUsername(this.loginForm.username)
            setRememberedPassword(this.loginForm.password)
          } else {
            setRememberMe(false)
            removeRememberedUsername()
            removeRememberedPassword()
          }
          let nextPath = await UserModule.LoginWithPassword(this.loginForm)


          if (this.redirect) {
            if (nextPath == '/select_org') {
              nextPath = '/select_org?redirect=' + this.redirect
              // nextPath = '/select_org'
            } else {
              nextPath = this.redirect
            }
          }

          this.$router.push({
            path: nextPath,
            query: this.otherQuery
          })
          // Just to simulate the time of the request
          setTimeout(() => {
            this.loading = false
          }, 0.5 * 1000)
        } catch (error) {
          // console.error('登录失败:', error)
          this.loading = false
        }
      } else {
        return false
      }
    })
  }

  public getOtherQuery(query: Dictionary<string>) {
    return Object.keys(query).reduce((acc, cur) => {
      if (cur !== 'redirect') {
        acc[cur] = query[cur]
      }
      return acc
    }, {} as Dictionary<string>)
  }
}
